<template>
  <div>
    <v-card-text>
      <v-form @submit.prevent="saveTeam" ref="form">
        <v-container
          class="mb-4"
          style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px" >
          <h3 class="mb-1 ml-2">
            {{ $t('inputs.captation_team.type_captation_team') }}<span style="color: red">*</span>
          </h3>
          <v-radio-group
            data-cy="captation-type"
            :rules="formRules"
            :disabled="disableRadioButton"
            v-model="captationTeamForm.type_captation_team_id"
            @change="getOrgonsList()"
            class="ml-2"
            row
          >
            <template>
              <v-radio
                data-cy="captacao-apenas-orgao"
                color="green"
                :label="$t('inputs.captation_team.only_orgons')"
                value="1"
                :disabled="captureOnlyTissues"
                @change="disableUnity = false"
              ></v-radio>
              <v-radio
                data-cy="captacao-apenas-tecidos"
                color="green"
                :label="$t('inputs.captation_team.only_tissues')"
                @change="fixFabrics()"
                value="2"
              ></v-radio>
            </template>
          </v-radio-group>

          <v-row
            class="mt-2"
            dense  
            v-if="captationTeamForm.type_captation_team_id"  
          >
            <v-col class="d-flex -1" cols="12" sm="3">
              <v-autocomplete
                data-cy="unidade-doadora"
                class="rounded-lg"
                color="#086318"
                :rules="formRules"
                :items="centers"
                item-text="hospital"
                item-value="id"
                :disabled="disableUnity"
                outlined
                dense
                v-model="captationTeamForm.donor_unity_id"
              >
                <template v-slot:label>
                  {{ $t('inputs.captation_team.donor_unity') }} <span style="color: red">*</span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" sm="3">
              <v-select
                data-cy="unidade-captadora"
                class="rounded-lg"
                color="#086318"
                :rules="formRules"
                :items="oposAndOpc"
                item-text="description" 
                :disabled="orgonsCaptureds.length == 0"
                item-value="id"
                outlined
                dense
                v-model="captationTeamForm.captation_unity_id"
              >
                <template v-slot:label>
                  {{ $t('inputs.captation_team.captation_unity') }} <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>

            <v-col class="d-flex" cols="12" sm="6">
              <v-select
                data-cy="selecione-orgao-captados-time"
                class="rounded-lg"
                color="#086318"
                :rules="formRules"
                :items="orgonsCaptureds"
                item-text="orgon.name"
                item-value="id"
                outlined
                multiple
                dense
                v-model="captationTeamForm.orgonsCaptureds"
                :disabled="!orgonsCaptureds || orgonsCaptureds.length === 0"
              >
                <template v-slot:label>
                  {{ $t('inputs.captation_team.select_orgons') }}
                  <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <h3 class="mt-5 ml-2">
            {{ $t('titles.captation_team') }}<span style="color: red">*</span>
          </h3>
          <v-row
            class="mt-6"
            v-for="(professional, index) in professionals"
            :key="index"
            dense
          >
            <v-col class="d-flex" cols="12" sm="5">
              <v-select
                data-cy="captador"
                class="rounded-lg select-captador"
                color="#086318"
                :rules="formRules"
                :disabled="orgonsCaptureds.length == 0"
                :items="members"
                item-text="name"
                item-value="id"
                :no-data-text="$t('messages.has_no_recruiter')"
                outlined
                dense
                @change="onCaptadorChange(professional, index)"
                v-model="professional.member_id"
              >
                <template v-slot:label>
                  {{ $t('inputs.captation_team.recruiter') }} <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>

            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                data-cy="registro"
                color="#086318"
                class="rounded-lg"
                disabled
                outlined
                dense
                maxlength="10"
                v-model="professional.register"
              >
                <template v-slot:label> {{ $t('inputs.captation_team.register_number') }} </template>
              </v-text-field>
            </v-col>

            <v-col class="d-flex" cols="12" sm="3">
              <v-select
                data-cy="profissao"
                color="#086318"
                class="rounded-lg"
                outlined
                dense
                disabled
                :items="profissions"
                item-value="id"
                item-text="description"
                v-model="professional.profession"
              >
                <template v-slot:label> {{ $t('inputs.captation_team.profession') }} </template>
              </v-select>
            </v-col>

            <v-col class="d-flex" cols="12" sm="2" v-if="index === 0">
              <v-tooltip top color="green">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    small
                    fab
                    dark
                    color="#41916b"
                    :disabled="orgonsCaptureds.length == 0"
                    v-bind="attrs"
                    v-on="on"
                    @click="addProfessional()"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span style="color: white">{{ $t('messages.add_professionals') }}</span>
              </v-tooltip>
              <v-tooltip bottom color="red">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    small
                    fab
                    dark
                    :disabled="orgonsCaptureds.length == 0"
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click="removeProfessional()"
                  >
                    <v-icon dark>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span style="color: white">{{ $t('messages.remove_professionals') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row dense class="d-flex mt-7">
            <v-col class="d-flex" cols="12" sm="auto">
              <v-btn 
              data-cy=salvar-equipe
              block 
              small 
              class="rounded-lg mb-1" 
              color="#41916b" 
              :disabled="orgonsCaptureds.length == 0"
              @click="saveTeam()">
                <span style="color: white"><v-icon class="mr-1">mdi-check</v-icon>{{$t('buttons.save_team')}}</span>
              </v-btn>
            </v-col>

            <v-spacer />

            <v-col class="d-flex" cols="12" sm="auto">
              <v-btn 
              block 
              small 
              class="rounded-lg" 
              color="#7db59a" 
              :disabled="orgonsCaptureds.length == 0"
              @click="dialog = true">
                <span style="color: white"><v-icon class="mr-1">mdi-account-plus</v-icon>{{ $t('buttons.new_recruiter') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <template>
          <v-data-table
            :headers="headers"
            :items="team"
            :items-per-page="10"
            :footer-props="{ 'items-per-page-text': 'Equipes por página' }"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }" :resource="item">
              <v-tooltip right color="red">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    size="20"
                    class="icon"
                    color="red"
                    v-on="on"
                    v-bind="attrs"
                    align-item="center"
                    @click="deleteTeam(item)"
                  >
                    mdi-trash-can-outline
                  </v-icon>
                </template>
                <span style="color: white">{{ $t('buttons.delete') }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.team_orgon_captureds`]="{ item }">
              <div class="d-flex flex-wrap">
                <v-chip
                  v-for="(orgon, index) in item.team_orgon_captureds"
                  :key="index"
                  color="#bce8d3"
                  text-color="red"
                  small
                  class="ma-1"
                >
                  {{ orgon.orgon_captured.orgon.name }}
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.members`]="{ item }">
              <div class="d-flex flex-wrap">
                <v-chip
                  v-for="(team, index) in item.members"
                  :key="index"
                  color="#bce8d3"
                  text-color="red"
                  small
                  class="ma-1"
                >
                  {{ team.name }}
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </template>
        <v-row class="mt-4">
          <v-col class="d-flex" cols="12" sm="auto">
            <v-btn
              class="rounded-lg ml-1 mb-1"
              elevation="0"
              block
              color="#41916b"
              @click="redirect()"
              v-if="canConcludeCaptation">
              <span style="color: white">{{ $t('buttons.conclude_captation') }}</span>
            </v-btn>
          </v-col>
          <v-col class="d-flex" cols="12" sm="auto"> 
            <v-btn
              class="rounded-lg mx-1 mb-1"
              elevation="0"
              block
              color="#89ab9b"
              @click="$emit('changeTab', donorData.kind_of_donor_id == 2 ? 2 : 1)"
            >
              <span style="color: white">{{$t('buttons.return')}}</span>
            </v-btn>
          </v-col>
          <v-col class="d-flex" cols="12" sm="auto">
            <BackToGridBtn />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="#41916b" dark>Cadastro de Captador</v-toolbar>
        <v-card-text>
          <v-container class="mt-5">
            <v-form @submit.prevent="newMember" ref="formData">
              <v-row>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    color="#086318"
                    class="rounded-lg"
                    :rules="formRules"
                    outlined
                    dense
                    v-model="memberForm.name"
                  >
                    <template v-slot:label>
                      {{ $t('inputs.captation_team.professional_name') }} <span style="color: red">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    color="#086318"
                    class="rounded-lg"
                    :rules="formRules"
                    outlined
                    dense
                    :items="profissions"
                    item-value="id"
                    item-text="description"
                    v-model="memberForm.profission_id"
                  >
                    <template v-slot:label>
                      {{ $t('inputs.captation_team.profession') }} <span style="color: red">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                    color="#086318"
                    class="rounded-lg"
                    :rules="formRules"
                    outlined
                    dense
                    v-model="memberForm.register"
                  >
                    <template v-slot:label>
                      Registro <span style="color: red">*</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog = false">{{$t('buttons.cancel')}}</v-btn>
          <v-btn
            color="#41916b"
            class="rounded-lg"
            dark
            :loading="loading"
            @click="saveNewMember()"
            >{{$t('buttons.save')}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import {
  getCaptationsTeams,
  getProfissionsList,
  getMembers,
  getUnities,
  getOrgonsStillNotCaptureds,
  getOposeOpcs,
} from "@/service/CaptationFieldsService";
import { mapGetters, mapActions } from "vuex";
import currentUser from "@/utils/currentUser";
import Formatters from "@/utils/Formatters";
import {compareStr} from "@/utils/compareStrings";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      headers: [
        {
          text: "Tipo de Equipe",
          align: "center",
          value: "type_captation_team.description",
        },
        {
          text: "Unidade Captadora",
          align: "center",
          value: "captation_unity.description",
        },
        {
          text: "Orgãos Captados pelo Time",
          align: "center",
          value: "team_orgon_captureds",
        },
        {
          text: "Time de Captação (Membros)",
          align: "center",
          value: "members",
        },
      ],
      dialog: false,
      tab: 3,
      loading: false,  
      team: [],   
      professionals: [
        {
          member_id: "",
          register: "",
          profession: "",
        },
      ],
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      memberForm: {},
      profissions: [], 
      members: [],
      centers: [],
      orgonsCaptureds: [],
      captationTeamForm: {},
      disableRadioButton: false,
      disableUnity: false,
      oposAndOpc: [],
      resourceId: null,
      eyeBankCnes: '9999888'
    };
  },

  components: {
    BackToGridBtn
  },

  props: {
    captationId: Number,
    typeCaptation: String,
  },

  async created() {
    if(this.resource){
      this.resourceId = this.resource.donor_id == this.donorData.id ? this.resource.id : null;
    }
    const id = this.captationId
      ? this.captationId
      : this.resourceId;  
    this.team = await getCaptationsTeams(id);
    //recupera o tipo salvo
      if (this.team.length > 0) {
          this.captationTeamForm.type_captation_team_id =
            String(this.team[this.team.length - 1].type_captation_team_id);
        }
  

    this.profissions = await getProfissionsList();
    this.members = await getMembers();
    this.centers = await getUnities();
    await this.getOrgonsList();
    this.enableButton = this.team.length >= 1;
  },

  watch: {
    donorData: {
      handler(item) { 
        if (item.kind_of_donor_id == "2") { 
          this.captationTeamForm.type_captation_team_id = "2";
          this.disableRadioButton = true;
          this.captationTeamForm.donor_unity_id = 92;
          this.disableUnity = true;
        }
      },
      immediate: true,
      deep: true,
    },

    'captureOnlyTissues': {
      handler(value) {
        if(value) {
          this.captationTeamForm.type_captation_team_id = '2';
        }
      },
      immediate: true
    },

    'typeCaptation': {
      handler(item) {
        this.changeCaptationTeamType(item);
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    ...mapGetters({
      donorData: "getPatientData",
      resource: "getCaptationData",
    }),

    currentUser(){
      return currentUser.getUserData()
    },

    currentCaptationId() {
      return this.captationId ||this.resource?.id ;
    },

    canConcludeCaptation() {
      return this.orgonsCaptureds.length == 0 && this.donorData.donor_status_slug != 'doacao-efetivada';
    },

    captureOnlyTissues() {
      return compareStr(this.donorData.encerramento_pme?.[0]?.tissue_harvesting_only_flg, 'sim')
    },  
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changePatientData", "changeCaptationData"]),

    addProfessional() {
      this.professionals.push({
        member_id: "",
        register: "",
        profession: "",
      });
    },

    changeCaptationTeamType(typeCaptation) {
      const isTissuesOnly = compareStr(typeCaptation, 'captouapenastecidos');

     // Não forçar "1" no changeCaptationTeamType
      
      // this.captationTeamForm.type_captation_team_id = isTissuesOnly ? '2' : '1';
       if (isTissuesOnly) {
    this.captationTeamForm.type_captation_team_id = '2';
  }
    },

    async getOrgonsList() {
      this.orgonsCaptureds = await getOrgonsStillNotCaptureds(
        this.donorData.id,
        this.captationTeamForm.type_captation_team_id
      );   

      this.oposAndOpc = await getOposeOpcs(
        this.captationTeamForm.type_captation_team_id
      );
      if (this.captationTeamForm.type_captation_team_id == "2") {
        this.fixFabrics();
      } else {
        this.captationTeamForm.donor_unity_id == 92
          ? (this.captationTeamForm.donor_unity_id = null)
          : this.captationTeamForm.type_captation_team_id;
        this.$refs.form.resetValidation();
      }  
    },

    onCaptadorChange(professional) {
      const selectedMember = this.members.find(
        (member) => member.id === professional.member_id
      );
      if (selectedMember) {
        professional.register = selectedMember.register || "";
        professional.profession =
          parseInt(selectedMember.profission_id) || null;
      }
    },

    removeProfessional() {
      if (this.professionals.length > 1) {
        this.professionals.pop();
      }
    },

    async getMembers() {
      this.members = await getMembers();
    },

    async saveTeam() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let members = this.professionals.map((x) => x.member_id);

        let professionalTeam = {
          user_id: this.currentUser.id,
          type_captation_team_id: this.captationTeamForm.type_captation_team_id,
          donor_unity_id: this.captationTeamForm.donor_unity_id,
          captation_unity_id: this.captationTeamForm.captation_unity_id,
          orgons_captured: this.captationTeamForm.orgonsCaptureds,
          members: members,
        };

        if (this.donorData.captation) { 
          professionalTeam.captation_id = this.donorData.captation.id;
        } else {  
          professionalTeam.captation_id = this.captationId ? this.captationId : this.donorData.captation_id;
        }

        try {
          const response = await axios.post(
            `/captations_team`,
            professionalTeam
          ); 

          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

            this.memberForm = {};
            this.captationTeamForm.captation_unity_id = null
            this.captationTeamForm.orgonsCaptureds = [];
            this.captationTeamForm.donor_unity_id = this.captationTeamForm.type_captation_team_id == '2' ? 92 : null
            this.professionals = [
              { member_id: "", register: "", profession: "" },
            ];
            this.$refs.form.resetValidation();
            this.dialog = false;

            const captationId = this.captationId
              ? this.captationId
              : this.donorData.captation_id;

            this.orgonsCaptureds = await getOrgonsStillNotCaptureds(
              this.donorData.id,
              this.captationTeamForm.type_captation_team_id
            );
 
            if(this.orgonsCaptureds.length == 0){
              let allOrgonsLength = await getOrgonsStillNotCaptureds(
                this.donorData.id 
              );

              if(allOrgonsLength.length == 0){
                this.disableRadioButton = true;
              }else{
                this.redirectToTissues(allOrgonsLength) 
              }
            }

            this.team = await getCaptationsTeams(captationId);

          setTimeout(() => {
            this.loading = false;
            this.closeSnackBar();
          }, 3000);
        } catch (err) {
          this.loading = false;
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: err.error,
            bodyMessage: err.details,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        }
      }
    },

    async redirectToTissues(allOrgonsLength) { 
      this.captationTeamForm.type_captation_team_id = "2"
      this.orgonsCaptureds = allOrgonsLength
      this.fixFabrics();
      this.oposAndOpc = await getOposeOpcs(
        this.captationTeamForm.type_captation_team_id
      );
    },

    foundEyeBankId() {
      return this.centers.find(unity => unity.CNES == this.eyeBankCnes)?.id ?? null;
    },

    async saveNewMember() {
      if (this.$refs.formData.validate()) {
        this.loading = true;
        let member = this.memberForm;
        member.user_id = this.currentUser.id;

        try {
          const response = await axios.post(`/members`, member);
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

          setTimeout(() => {
            this.loading = false;
            this.closeSnackBar();
            this.memberForm = {};
            this.dialog = false;
            this.$refs.formData.resetValidation();
            this.getMembers();
          }, 2000);
        } catch (err) {
          this.loading = false; 
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: err.error,
            bodyMessage: Formatters.formatErrorMessage(err),
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        }
      }
    },

    async deleteTeam(item) {
      try {
        const response = await axios.delete(`/captations_team/${item.id}`);
        this.changeSnackBarData({
          status: true,
          type: "success",
          titleMessage: response.data.message,
          bodyMessage: "",
          cardColor: "#41916b",
          titleIcon: "mdi-checkbox-marked-circle",
        });
        this.team = await getCaptationsTeams(this.currentCaptationId);
        setTimeout(() => {
          this.closeSnackBar();
        }, 3000);
      } catch (err) {
        this.changeSnackBarData({
          status: true,
          type: "erro",
          titleMessage: err.error,
          bodyMessage: Formatters.formatErrorMessage(err),
          cardColor: "red",
          titleIcon: "mdi-close-circle",
        });
        setTimeout(() => {
          this.closeSnackBar();
        }, 5000);
      }
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },

    fixFabrics() {
      this.captationTeamForm.donor_unity_id = this.foundEyeBankId();
      this.disableUnity = true;
    },

     async redirect() {
      try{

         this.loading = true

         if (this.orgonsCaptureds && this.orgonsCaptureds.length > 0) {
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Ainda existe orgão sem equipe!",
            bodyMessage: "Associe todos os orgão à uma equipe antes de concluir.",
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });


          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);

          return

        }else {
          await axios.post('/captations_team/conclude',{
            captation_id: this.currentCaptationId
          })
                       
      if (this.donorData) {
        this.changePatientData(this.donorData);
        this.changeCaptationData(this.captationId)
      }
      this.loading = false;
      this.$router.push("/orgaos-captados");

    }
  }catch(error){
      this.changeSnackBarData({
        status: true,
        type: "erro",
        titleMessage: error.error,
        bodyMessage: error.details,
        cardColor: "red",
        titleIcon: "mdi-close-circle",
      });

      setTimeout(() => {
        this.closeSnackBar();
      }, 5000);
    }
    },
  },
};
</script>

<style scoped>
.d-flex {
  padding: 0 12px;
}

.select-captador .v-label {
  transform: translateY(6px) !important; /* ajuste o valor se precisar */
}

.select-captador.v-input--is-focused .v-label,
.select-captador.v-input--is-label-active .v-label {
  transform: translateY(6px) !important;
}
</style>
